import React, { Component } from 'react';
import { Row } from 'reactstrap';
import LoaderWrapper from '../../../Components-2025/QuestionBank/LoaderWrapper';
import VideoCard from '../../../Components-2025/Videos/videoCard';
import ComponentHeader from '../../../common/ComponentHeader';
import { messages } from '../../../common/messages';
import ModalComponent from '../../Common/Modal';
import config from '../../config/AppRoutes';
import { nextAwareRoute } from '../../../common/cfa1NextRoutes';
import { chapterIdKey, chapterNameKey, videoTableChapterIdKey } from './ApiAttributesKays';
import apiServiceProvider from './ApiService';
import { showInformation } from '../../../common/toast';
import { slugifyHeader } from '../../../common/function';
import './VideoCategoryNav.css';
let videoTableNameKey = 'cfa1_2025_videos';

/* eslint-disable*/

export default class index extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      videoData: [],
      isLoading: true,
      isPremiumPopupOpen: false,
      isLastVideoViewButtonDisable: false,
      isUserSubscriptionStatus: false,
      // Unlimited+ marker for the Live Sessions playback gate; comes from
      // the backend's cfaSubscriptionCheckMiddleware so pkg-15+pkg-78 co-
      // holders are recognised even when the middleware short-circuits.
      hasPlusAccess: false,
    };
  }
  async componentDidMount() {
    this.setState({ isLoading: true });
    await this.retrieveVideos();
  }

  retrieveVideos = async () => {
    const result = await apiServiceProvider['fetchVideos']();
    if (result.success) {
      videoTableNameKey = result.associatedVideosTable;
      this.setState({
        isLoading: false,
        videoData: result.data,
        isUserSubscriptionStatus:
          result.selectedExamSubscriptionDetails.level1SubscriptionDetails &&
          result.selectedExamSubscriptionDetails.level1SubscriptionDetails.videoStatus,
        hasPlusAccess: !!result.selectedExamSubscriptionDetails.hasCfaPlus,
      });
    } else {
      this.setState({ isLoading: false });
    }
  };

  redirectToSubscription = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };

  scrollToSection = (headerTitle) => {
    const element = document.getElementById(slugifyHeader(headerTitle));
    if (element && element.scrollIntoView) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  onHandleToggleAlert = () => {
    this.setState({ isPremiumPopupOpen: !this.state.isPremiumPopupOpen });
  };

  redirectToPlaylist = (items) => {
    const { router } = this.context;
    const { id } = items;
    router.push({
      pathname: nextAwareRoute(config.CFA1_VIDEO_LIST)
        .replace(':chapterId', items[videoTableChapterIdKey])
        .replace(':id', id),
      query: {
        ...(items.mock_id && { mockId: items.mock_id }),
        ...(items.media_type === 'webinar' && { mediaType: 'webinar' }),
      },
    });
  };
  redirectToLastViewedVideo = async () => {
    this.setState({ isLastVideoViewButtonDisable: true });
    const result = await apiServiceProvider['fetchLastViewedVideo']();
    if (result.success) {
      const { router } = this.context;
      const { data, associatedVideosTable } = result;
      router.push({
        pathname: nextAwareRoute(config.CFA1_VIDEO_LIST).replace(
          ':chapterId',
          data[associatedVideosTable] ? data[associatedVideosTable][videoTableChapterIdKey] : null,
        ).replace(':id', data.contentID),
        query: {
          ...(data[associatedVideosTable].mock_id && {
            mockId: data[associatedVideosTable].mock_id,
          }),
          ...(data[associatedVideosTable].media_type === 'webinar' && {
            mediaType: 'webinar',
          }),
        },
      });
    } else {
      this.setState({ isLastVideoViewButtonDisable: false });
      showInformation(messages.VIDEO_NOT_AVAILABLE);
    }
  };
  render() {
    const { state } = this;
    const {
      isLoading,
      isPremiumPopupOpen,
      isUserSubscriptionStatus,
      hasPlusAccess,
      isLastVideoViewButtonDisable,
      videoData,
    } = state;
    let resetIndex = false;
    let counterIndex = 1;
    const sectionHeaders = videoData
      .filter((item) => item.headerTitle)
      .map((item) => item.headerTitle);
    return (
      <div className='animated fadeIn'>
        <div>
          <ComponentHeader title={messages.VIDEOS} className='mb-3'>
            <div className='d-flex align-items-center flex-wrap video-category-header-actions'>
              {sectionHeaders.length > 1 && (
                <div className='video-category-anchors mr-3'>
                  {sectionHeaders.map((headerTitle) => (
                    <button
                      key={headerTitle}
                      type='button'
                      className='btn btn-link video-category-anchor'
                      onClick={() => this.scrollToSection(headerTitle)}
                    >
                      {headerTitle}
                    </button>
                  ))}
                </div>
              )}
              <button
                className='btn btn-primary pointer_class'
                onClick={() => this.redirectToLastViewedVideo()}
                disabled={isLastVideoViewButtonDisable}
              >
                {isLastVideoViewButtonDisable && <i className='fa fa-spinner fa-spin mr-1' />}
                {messages.GO_TO_MY_LAST_VIEWED_VIDEO}
              </button>
            </div>
          </ComponentHeader>
          <LoaderWrapper isLoading={isLoading}>
            <Row className='video_lesson_wrap'>
              {videoData.length > 0 &&
                videoData.map((item, index) => {
                  if (item.mock_id && !resetIndex) {
                    resetIndex = true;
                    counterIndex = 1;
                  }
                  return (
                    <VideoCard
                      key={index}
                      index={counterIndex++}
                      currentItem={item}
                      chapterIdKey={chapterIdKey}
                      chapterNameKey={chapterNameKey}
                      videoTableNameKey={videoTableNameKey}
                      onHandleRedirect
                      isUserSubscribed={isUserSubscriptionStatus}
                      hasPlusAccess={hasPlusAccess}
                      premiumModalToggle={this.onHandleToggleAlert}
                      redirectToPlaylist={this.redirectToPlaylist}
                    />
                  );
                })}
            </Row>
          </LoaderWrapper>
        </div>
        {/* //* THIS IS FOR PREMIUM POPUP  */}
        <ModalComponent
          goPremium={this.redirectToSubscription}
          toggleAlert={this.onHandleToggleAlert}
          alert_status={isPremiumPopupOpen}
          MessageContent={messages.CFA1_2025_PREMIUM_POPUP}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Videos/index.jsx